export default __webpack_public_path__ + "static/media/navi_logo.87bb72bf.svg";